module.exports = __webpack_public_path__ + "img/cx.b81dd1d9.svg";